import { useEffect, useState } from "react";

export default function LogoIntro() {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setShow(false), 2600);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;
  return (
    <div
      data-testid="logo-intro"
      className="logo-overlay fixed inset-0 z-[100] bg-[var(--niko-dark)] flex items-center justify-center px-8"
    >
      <div className="logo-overlay-inner text-center">
        <img
          src="/brand/nikos-logo-dark.png"
          alt="Niko's Grillhouse"
          className="mx-auto select-none"
          style={{ width: "min(420px, 70vw)", height: "auto" }}
          draggable="false"
        />
        <p className="mt-6 font-greek italic text-[var(--niko-gold)] text-sm tracking-[0.4em]">
          ΗÖNTROP · SEIT 44 JAHREN
        </p>
      </div>
    </div>
  );
}
